import { render, staticRenderFns } from "./ModalHaveClaimRetur.vue?vue&type=template&id=4f460412&"
import script from "./ModalHaveClaimRetur.vue?vue&type=script&lang=js&"
export * from "./ModalHaveClaimRetur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports